// extracted by mini-css-extract-plugin
export var checkbox = "Controls-module--checkbox--95739";
export var checkboxLabel = "Controls-module--checkboxLabel--826d4";
export var container = "Controls-module--container--e2b76";
export var label = "Controls-module--label--7d5a0";
export var options = "Controls-module--options--ee16b";